// PersonalCareServicesSection.js
import React from 'react';
import { Phone, Check } from 'lucide-react';

const PersonalCareServicesSection = () => {
  const services = [
    { left: 'Meal preparation', right: 'Mobility assistance' },
    { left: 'Showering and bathing assistance', right: 'Help with transfers or going up and down the stairs' },
    { left: 'Incontinence support', right: 'Positioning and proper movements' },
    { left: 'Meal time assistance', right: 'And more!' }
  ];

  return (
    <section className="bg-cream py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
            Personal Care
          </p>
          <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
            Personal Care Services Tailored to Your Needs
          </h2>

          <div className="space-y-4 text-muted text-base leading-relaxed mb-4">
            <p>
              As we get older, or as a disability makes daily life harder, simply looking after yourself can feel like a struggle. Everyday tasks such as showering or preparing a meal can become stressful and difficult. At Wei Care, we understand how challenging this can be, which is why we offer the respectful, responsive care you can rely on.
            </p>

            <p className="text-ink font-medium">Here are a few of the many services included in our personal care:</p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="space-y-5 my-10 max-w-3xl mx-auto">
          {services.map((service, index) => (
            <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="flex items-start gap-3">
                <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-7 h-7 rounded-full border border-primary text-primary">
                  <Check size={15} />
                </span>
                <span className="text-ink text-base">{service.left}</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-7 h-7 rounded-full border border-primary text-primary">
                  <Check size={15} />
                </span>
                <span className="text-ink text-base">{service.right}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center max-w-3xl mx-auto">
          <p className="text-muted text-base leading-relaxed mb-8">
            We are utterly committed to providing the support you need to live life the way you want. If you would like to experience our care today, please give us a call. We are here to ensure you receive the care you deserve.
          </p>

          <a
            href="tel:+61480804640"
            className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
          >
            <Phone size={18} />
            Call +61 420 162 243
          </a>
        </div>
      </div>
    </section>
  );
};

export default PersonalCareServicesSection;
